// extracted by mini-css-extract-plugin
module.exports = {"results":"Results_results__v0HOD","tab":"Results_tab__TRdOe","category":"Results_category__1Q8Gm","active":"Results_active__ZWuxA","backdrop":"Results_backdrop__PZfjP"};